<template>
  <section>

    <b-tabs>
      <b-tab-item label="My Clients">
        <b-field grouped group-multiline>
          <b-select v-model="defaultSortDirection">
            <option value="asc">Default sort direction: ASC</option>
            <option value="desc">Default sort direction: DESC</option>
          </b-select>
          <b-select v-model="perPage" :disabled="!isPaginated">
            <option value="5">5 per page</option>
            <option value="10">10 per page</option>
            <option value="15">15 per page</option>
            <option value="20">20 per page</option>
          </b-select>
          <div class="control is-flex">
            <b-switch v-model="isPaginated">Paginated</b-switch>
          </div>
          <!-- <div class="control is-flex">
            <b-switch v-model="isPaginationSimple" :disabled="!isPaginated">Simple pagination</b-switch>
          </div> -->
        </b-field>
        <b-table
          :data="isEmpty ? [] : data"
          striped
          hoverable
          ref="table"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          :default-sort-direction="defaultSortDirection"
          default-sort="user.first_name"
          :opened-detailed="defaultOpenedDetails"
          detailed
          detail-key="id"
          @details-open="(row, index) => $toast.open(`Expanded ${row.user.first_name}`)"
          :show-detail-icon="showDetailIcon"
        >

          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric sortable>
              {{ props.row.id }}
            </b-table-column>

            <b-table-column field="user.first_name" label="First Name" sortable>
              <template v-if="showDetailIcon">
                {{ props.row.user.first_name }}
              </template>
              <template v-else>
                <a @click="toggle(props.row)">
                  {{ props.row.user.first_name }}
                </a>
              </template>
            </b-table-column>

            <b-table-column field="user.last_name" label="Last Name" sortable>
              {{ props.row.user.last_name }}
            </b-table-column>

            <b-table-column field="date" label="Date" sortable centered>
                        <span class="tag is-success">
                            {{ new Date(props.row.date).toLocaleDateString() }}
                        </span>
            </b-table-column>

            <b-table-column label="Gender">
              <b-icon pack="fa"
                      :icon="props.row.gender === 'Male' ? 'mars' : 'venus'">
              </b-icon>
              {{ props.row.gender }}
            </b-table-column>
          </template>

          <template slot="detail" slot-scope="props">
            <article class="media">
              <figure class="media-left">
                <p class="image is-64x64">
                  <img src="/static/img/placeholder-128x128.png">
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <p>
                    <strong>{{ props.row.user.first_name }} {{ props.row.user.last_name }}</strong>
                    <small>@{{ props.row.user.first_name }}</small>
                    <small>31m</small>
                    <br>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Proin ornare magna eros, eu pellentesque tortor vestibulum ut.
                    Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis.
                  </p>
                </div>
              </div>
            </article>
          </template>
        </b-table>
      </b-tab-item>

      <b-tab-item label="All Clients">
        <b-field grouped group-multiline>
          <b-select v-model="defaultSortDirection">
            <option value="asc">Default sort direction: ASC</option>
            <option value="desc">Default sort direction: DESC</option>
          </b-select>
          <b-select v-model="perPage" :disabled="!isPaginated">
            <option value="5">5 per page</option>
            <option value="10">10 per page</option>
            <option value="15">15 per page</option>
            <option value="20">20 per page</option>
          </b-select>
          <div class="control is-flex">
            <b-switch v-model="isPaginated">Paginated</b-switch>
          </div>
          <!-- <div class="control is-flex">
            <b-switch v-model="isPaginationSimple" :disabled="!isPaginated">Simple pagination</b-switch>
          </div> -->
        </b-field>
        <b-table
          :data="isEmpty ? [] : data"
          striped
          hoverable
          ref="table"
          :paginated="isPaginated"
          :per-page="perPage"
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          :default-sort-direction="defaultSortDirection"
          default-sort="user.first_name"
          :opened-detailed="defaultOpenedDetails"
          detailed
          detail-key="id"
          @details-open="(row, index) => $toast.open(`Expanded ${row.user.first_name}`)"
          :show-detail-icon="showDetailIcon"
        >

          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric sortable>
              {{ props.row.id }}
            </b-table-column>

            <b-table-column field="user.first_name" label="First Name" sortable>
              <template v-if="showDetailIcon">
                {{ props.row.user.first_name }}
              </template>
              <template v-else>
                <a @click="toggle(props.row)">
                  {{ props.row.user.first_name }}
                </a>
              </template>
            </b-table-column>

            <b-table-column field="user.last_name" label="Last Name" sortable>
              {{ props.row.user.last_name }}
            </b-table-column>

            <b-table-column field="date" label="Date" sortable centered>
                        <span class="tag is-success">
                            {{ new Date(props.row.date).toLocaleDateString() }}
                        </span>
            </b-table-column>

            <b-table-column label="Gender">
              <b-icon pack="fa"
                      :icon="props.row.gender === 'Male' ? 'mars' : 'venus'">
              </b-icon>
              {{ props.row.gender }}
            </b-table-column>
          </template>

          <template slot="detail" slot-scope="props">
            <article class="media">
              <figure class="media-left">
                <p class="image is-64x64">
                  <img src="/static/img/placeholder-128x128.png">
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <p>
                    <strong>{{ props.row.user.first_name }} {{ props.row.user.last_name }}</strong>
                    <small>@{{ props.row.user.first_name }}</small>
                    <small>31m</small>
                    <br>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Proin ornare magna eros, eu pellentesque tortor vestibulum ut.
                    Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis.
                  </p>
                  <div class="buttons">
                    <button class="button is-primary"
                    @click="isSettingsCardModalActive = true">Settings1</button>
                    <button class="button"><router-link :to="`/client/${props.row.id}`">Lead Details</router-link></button>
                    <button class="button"><router-link :to="`/leads/${props.row.id}`">View Leads</router-link></button>
                    <a class="button is-danger is-outlined">Pause</a>
                  </div>
                </div>
              </div>
            </article>

            <b-modal :active.sync="isSettingsCardModalActive" :width="640" scroll="keep">
              <div class="card">
                <div class="card-content">
                  <div class="media">
                    <!-- <div class="media-left">
                      <figure class="image is-48x48">
                        <img src="/static/img/placeholder-1280x960.png" alt="Image">
                      </figure>
                    </div> -->
                    <div class="media-content">
                      <p class="title is-4">{{ props.row.user.first_name }} {{ props.row.user.last_name }}</p>
                      <p class="subtitle is-6">@{{ props.row.user.first_name }}{{ props.row.user.last_name }}</p>
                    </div>
                  </div>

                  <div class="form">
                    <div class="field">
                      <label class="label">Client Name</label>
                      <div class="control has-icons-left has-icons-right">
                        <input class="input" type="email" placeholder="Extra small">
                        <span class="icon is-small is-left">
                          <i class="fas fa-envelope fa-xs"></i>
                        </span>
                        <span class="icon is-small is-right">
                          <i class="fas fa-check fa-xs"></i>
                        </span>
                      </div>
                    </div>

                    <div class="field">
                      <label class="label">Client Name</label>
                      <div class="control has-icons-left has-icons-right">
                        <input class="input" type="email" placeholder="Extra small">
                        <span class="icon is-small is-left">
                          <i class="fas fa-envelope fa-xs"></i>
                        </span>
                        <span class="icon is-small is-right">
                          <i class="fas fa-check fa-xs"></i>
                        </span>
                      </div>
                    </div>

                    <div class="field">
                      <label class="label">Client Name</label>
                      <div class="control has-icons-left has-icons-right">
                        <input class="input" type="email" placeholder="Extra small">
                        <span class="icon is-small is-left">
                          <i class="fas fa-envelope fa-xs"></i>
                        </span>
                        <span class="icon is-small is-right">
                          <i class="fas fa-check fa-xs"></i>
                        </span>
                      </div>
                    </div>

                    <div class="control">
                      <div class="select">
                        <select>
                          <option>Select dropdown</option>
                          <option>With options</option>
                        </select>
                      </div>
                    </div>

                    <div class="control">
                      <b-checkbox>Remember me</b-checkbox>
                    </div>
                  </div>

                  <div class="content">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Phasellus nec iaculis mauris. <a>@bulmaio</a>.
                    <a>#css</a> <a>#responsive</a>
                    <br>
                    <small>11:09 PM - 1 Jan 2016</small>
                  </div>

                  <div class="field is-grouped is-grouped-centered">
                    <p class="control">
                      <a class="button is-primary">
                        Save
                      </a>
                    </p>
                    <p class="control">
                      <button class="button is-light"
                              type="button"
                              @click="$parent.close()">
                        Cancel
                      </button>
                    </p>
                  </div>
                </div>
                <!-- <footer class="card-footer">
                  <a href="#" class="card-footer-item">Save</a>
                  <a href="#" class="card-footer-item">Edit</a>
                  <a href="#" class="card-footer-item">Delete</a>
                </footer> -->
              </div>
            </b-modal>
          </template>

        </b-table>
      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import data from '@/data/sample.json'

export default {
  name: 'ClientsList',
  data () {
    return {
      data,
      defaultOpenedDetails: [1],
      showDetailIcon: true,
      isPaginated: true,
      isPaginationSimple: false,
      defaultSortDirection: 'asc',
      currentPage: 1,
      perPage: 10,
      isEmpty: false,
      isSettingsCardModalActive: false
    }
  },
  methods: {
    toggle (row) {
      this.$refs.table.toggleDetails(row)
    },
    cardModal (row) {
      this.$modal.open({
        parent: this,
        // component: ModalForm,
        isSettingsCardModalActive: true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/ClientsList.vue